import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col } from 'react-bootstrap';
import { extractContent, getDate } from '../../../helpers/utils';
import config from '../../../config/config';
import Link from 'next/link';

const ArticleCard = ({ item, baseUrl }: any) => {
  return (
    item && (
      <Col className="app-article-card">
        <Card>
          {item.featuredImage && (
            <Link href={baseUrl ? baseUrl + item.slug : item.slug} aria-label={baseUrl ? baseUrl + item.slug : item.slug}>
              <a>
                <div
                  className="card-img-top"
                  style={{
                    backgroundImage: `url(${item.featuredImage ? config.baseUrl + item.featuredImage.url : ''})`
                  }}
                >
                  <div className="overlay" />
                </div>
              </a>
            </Link>
          )}
          <Card.Body>
            <Link href={baseUrl ? baseUrl + item.slug : item.slug}>
              <a className="article-title">
                <Card.Title> {item.title} </Card.Title>
              </a>
            </Link>
            <Card.Text>{extractContent(item.body, 150)}</Card.Text>
            <Link href={baseUrl ? baseUrl + item.slug : item.slug}>
              <a className="read-more">Read More »</a>
            </Link>
          </Card.Body>
          <Card.Footer>
            <span>{getDate(item.updated_at)}</span>
            <span>{item.post_comments.length > 0 ? item.post_comments.length + ' comments' : 'No Comments'}</span>
          </Card.Footer>
        </Card>
      </Col>
    )
  );
};

ArticleCard.propTypes = {
  item: PropTypes.any.isRequired,
  baseUrl: PropTypes.string.isRequired
};

export default ArticleCard;
